<template>
	<div class="subtitle">
		<slot></slot>
	</div>
</template>

<style lang="scss">
.subtitle {
	text-align: center;
	font-size: 1.1rem;
	margin-top: 0.5rem;
}
</style>
